import { MEMBERSHIP_EXTENSION_MODULE } from "@/api_framework/api_config";
import {
  IMembershipExtensionConnectedMembershipResponse,
  IMembershipExtensionConnectedMembershipResponseData,
} from "@/api_framework/api_modals/MembershipExtension";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useMembershipExtensionConnectedMembershipsAPI = () => {
  const [connectedMemberships, setConnectedMemberships] = useState<
    IMembershipExtensionConnectedMembershipResponseData[]
  >([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_CONNECTED_MEMBERSHIPS?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IMembershipExtensionConnectedMembershipResponse>) => {
          if (res.data.status === true) {
            setConnectedMemberships(res?.data?.data ?? []);
          } else {
            setConnectedMemberships([]);
          }
        })
        .catch((e: AxiosError) => {
          setConnectedMemberships([]);
          sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (error) {
      setConnectedMemberships([]);
    }
  }, [dispatch, configuration]);

  return { execute, connectedMemberships };
};
